import React from 'react';

const Newsletter2022Preview = ({ content }) => {
  return (
    <div className="font-sans text-sm" style={{ fontFamily: 'Arial, sans-serif' }}>
      {/* Header */}
      <div className="bg-gradient-to-r from-teal-500 to-teal-600 text-white p-6">
        <div className="flex justify-between items-start">
          <div>
            <h1 className="text-3xl font-bold tracking-wide">
              {content.header?.community_name || 'VISTA LAKES'}
            </h1>
            <p className="text-teal-100 text-sm mt-1">
              Volume {content.header?.volume || '24'} Number {content.header?.number || '7'}
            </p>
          </div>
          <div className="text-right">
            <p className="text-2xl font-bold">
              {content.header?.month || 'July'} {content.header?.year || '2025'}
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="p-6">
        {/* Featured Article */}
        <div className="mb-6">
          <h2 className="text-xl font-bold text-teal-700 mb-2 border-b-2 border-teal-200 pb-1">
            {content.featured?.title || 'Featured Article'}
          </h2>
          <p className="text-gray-700 leading-relaxed">
            {content.featured?.body || 'Add your featured article content here...'}
          </p>
        </div>

        {/* Two Column Layout */}
        <div className="grid grid-cols-2 gap-6">
          {/* Left Column */}
          <div className="space-y-4">
            {/* From the Board */}
            <div className="bg-teal-50 p-4 rounded-lg">
              <h3 className="font-bold text-teal-800 mb-2">
                {content.from_board?.title || 'From the Board'}
              </h3>
              <p className="text-sm text-gray-700">
                {content.from_board?.body || 'Add board message here...'}
              </p>
            </div>
          </div>

          {/* Right Column */}
          <div className="space-y-4">
            {/* In Our Community */}
            <div className="bg-yellow-50 p-4 rounded-lg">
              <h3 className="font-bold text-yellow-800 mb-2">
                {content.community?.title || 'In Our Community'}
              </h3>
              {content.community?.articles?.length > 0 ? (
                content.community.articles.map((article, index) => (
                  <div key={index} className="mb-2">
                    <p className="font-medium text-sm">{article.title}</p>
                    <p className="text-xs text-gray-600">{article.body}</p>
                  </div>
                ))
              ) : (
                <p className="text-sm text-gray-500">Add community articles...</p>
              )}
            </div>
          </div>
        </div>

        {/* Calendar Section */}
        <div className="mt-6 bg-orange-50 p-4 rounded-lg">
          <h3 className="font-bold text-orange-800 mb-3 border-b border-orange-200 pb-1">
            {content.calendar?.title || 'Calendar'}
          </h3>
          <div className="grid grid-cols-3 gap-4">
            {content.calendar?.events?.length > 0 ? (
              content.calendar.events.map((event, index) => (
                <div key={index} className="bg-white p-2 rounded shadow-sm">
                  <p className="font-bold text-sm text-orange-700">{event.date}</p>
                  <p className="text-xs text-gray-600">{event.title}</p>
                </div>
              ))
            ) : (
              <p className="text-sm text-gray-500 col-span-3">No events scheduled</p>
            )}
          </div>
        </div>

        {/* Contacts */}
        <div className="mt-6 border-t pt-4">
          <h3 className="font-bold text-gray-800 mb-3">
            {content.contacts?.title || 'Contacts'}
          </h3>
          <div className="grid grid-cols-2 gap-2 text-sm">
            {content.contacts?.list?.length > 0 ? (
              content.contacts.list.map((contact, index) => (
                <div key={index}>
                  <span className="text-gray-600">{contact.role}: </span>
                  <span className="font-medium">{contact.name}</span>
                </div>
              ))
            ) : (
              <p className="text-gray-500">Add contacts...</p>
            )}
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-teal-600 text-white text-center py-3 text-sm">
        <p>{content.header?.community_name || 'Vista Lakes'}FL.com</p>
      </div>
    </div>
  );
};

export default Newsletter2022Preview;
